import React from 'react';
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useForm } from "react-hook-form";

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import { setFilter } from "../../../redux/actions/generics/IndexedActions";

const MenuFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            ...data
        };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        reset({
            url: '',
            name: ''
        });

        props.setFilter(path, {});
    }

    return (<Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Nombre</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder="Filtro por Nombre"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>Componente / Vista</Label>
                        <Input
                            type="text"
                            name="url"
                            placeholder="Identificador de vista"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <ButtonSearch />
                    <ButtonClean onClick={() => cleanFields()} />
                </Col>
            </Row>
        </CardBody>
    </Form>);
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(MenuFilters)